export default __webpack_public_path__ + "/dist/images/222181.png";